import React, { useEffect } from "react";
import { billingImg } from "../../assets/image";
import { BackButton, Badge } from "../../components/micro";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { SubscriptionIcon } from "../../assets/svg/AllSvg";
import { useDispatch, useSelector } from "react-redux";
import {
  autoRenewalSubscription,
  cancelRenewalSubscription,
  getSubscriptionDetails,
} from "../../redux/billingSubscriptions/slice";
import RippleLoader from "../../commons/RippleLoader";
import moment from "moment";
import DataNotFound from "../../commons/DataNotFound";

const MySubscription = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const company_id = sessionStorage.getItem("companyID");
  const SubscriptionInfo = location?.state;

  // selector
  const { getSubscriptionDetailsData, loading } = useSelector((store) => ({
    getSubscriptionDetailsData:
      store?.billingSubscriptionsData?.getSubscriptionDetailsStatus?.data?.data,
    loading: store?.billingSubscriptionsData?.loading,
  }));

  useEffect(() => {
    if (SubscriptionInfo?.id) {
      dispatch(getSubscriptionDetails(SubscriptionInfo?.id)); // get subscription details
    }
  }, [dispatch, SubscriptionInfo]);

  // Cancel Renewal Subscription
  const handleCancelRenewal = () => {
    dispatch(cancelRenewalSubscription(SubscriptionInfo?.id)).then((res) => {
      if (res.type === "cancelRenewalSubscription/fulfilled") {
        dispatch(getSubscriptionDetails(SubscriptionInfo?.id));
      }
    });
  };

  // Auto Renewal Subscription
  const handleAutoRenewal = () => {
    dispatch(autoRenewalSubscription(SubscriptionInfo?.id)).then((res) => {
      if (res.type === "autoRenewalSubscription/fulfilled") {
        dispatch(getSubscriptionDetails(SubscriptionInfo?.id));
      }
    });
  };

  return (
    <div className="space-y-5">
      <BackButton
        onClick={() => navigate("/billing-subscriptions")}
        className={"mb-3"}
      />
      {/* Page Heading */}
      <div className="flex items-center gap-4 border-b-2 pb-5">
        <div className="w-40">
          <img src={billingImg} alt="billingImg" className="w-full" />
        </div>
        <div>
          <h1 className="xl:text-3xl lg:text-2xl sm:text-xl text-base font-ebGaramond mb-2">
            My Subscriptions
          </h1>
          <p className="sm:text-sm text-xs">Manage your subscriptions</p>
        </div>
      </div>
      {loading ? (
        <RippleLoader />
      ) : (
        <>
          {!getSubscriptionDetailsData ? (
            <DataNotFound />
          ) : (
            <>
              {/* My Subscription Details */}
              <div className="card bg-light_secondary_shades flex items-center justify-between !px-6 gap-5">
                <div className="flex items-center gap-5">
                  <div className="xl:max-w-14 lg:max-w-12 max-w-10 w-full">
                    <SubscriptionIcon className="w-full" />
                  </div>
                  <div className="space-y-3 w-full">
                    <p className="sm:text-xl text-base font-ebGaramond mb-2">
                      My Subscription
                    </p>
                    <div>
                      <p className="text-xs text-light_grey">
                        Subscription Type
                      </p>
                      <p className="sm:text-sm text-xs">
                        {getSubscriptionDetailsData?.duration} Year
                      </p>
                    </div>
                    <div>
                      <p className="text-xs text-light_grey">Expired on </p>
                      <p className="sm:text-sm text-xs">
                        {moment(getSubscriptionDetailsData?.end_date).format(
                          "DD/MM/YYYY"
                        )}{" "}
                      </p>
                    </div>
                  </div>
                </div>
                <button
                  className="btn-theme uppercase text-sm"
                  onClick={() =>
                    navigate("/payment-last", {
                      state: {
                        companyId: company_id,
                      },
                    })
                  }
                >
                  Change my subscription
                </button>
              </div>
              {/* Billing */}
              <div className="card bg-primary_shades_light flex items-center justify-between !px-6 gap-4">
                <div className="space-y-3">
                  <div className="flex items-center space-x-3">
                    <p className="sm:text-xl text-base font-ebGaramond">
                      Billing
                    </p>
                    <Badge
                      value={
                        getSubscriptionDetailsData?.type === "recurring"
                          ? "Auto Renewal"
                          : "Cancel Auto Renewal"
                      }
                      className={`${
                        getSubscriptionDetailsData?.type === "recurring"
                          ? "bg-green"
                          : "bg-warning_color"
                      } text-white text-xs capitalize !py-1`}
                    />
                  </div>
                  <div className="grid grid-cols-2 gap-5">
                    <div className="border-r-2 border-secondary_grey">
                      <p className="text-xs text-light_grey">Expired on</p>
                      <p className="sm:text-sm text-xs">
                        {moment(getSubscriptionDetailsData?.end_date).format(
                          "DD/MM/YYYY"
                        )}
                      </p>
                    </div>
                    <div>
                      <p className="text-xs text-light_grey">
                        Next Deduction Date
                      </p>
                      <p className="sm:text-sm text-xs">
                        {moment(
                          getSubscriptionDetailsData?.next_renewal_date
                        ).format("DD/MM/YYYY")}
                      </p>
                    </div>
                  </div>
                </div>
                <button
                  className={` ${
                    loading ? "btn-outline-disabled" : "btn-outline"
                  }  uppercase text-sm`}
                  disabled={loading}
                  onClick={
                    getSubscriptionDetailsData?.type === "recurring"
                      ? handleCancelRenewal
                      : handleAutoRenewal
                  }
                >
                  {getSubscriptionDetailsData?.type === "recurring"
                    ? "Cancel Auto Renewal"
                    : "Renew now"}
                </button>
              </div>
              {/* To Note: */}
              <div className="card bg-primary_shades_light flex items-center justify-between !px-6 gap-4">
                <div>
                  <p className="text-xs text-light_grey">Expired on</p>
                  <p className="sm:text-sm text-xs">
                    For our subscription plans. There will be strictly no
                    refunds
                  </p>
                  <Link to={"/subscription"} className="text-theme text-xs">
                    Our T&C here
                  </Link>
                </div>
                <button
                  className={`btn-normal uppercase text-sm`}
                  disabled={loading}
                  onClick={handleCancelRenewal}
                >
                  Cancel Subscription
                </button>
              </div>
            </>
          )}
        </>
      )}
    </div>
  );
};

export default MySubscription;
